import { __rest } from "tslib";
import { SORT_ORDER_OPTIONS } from './constants';
import { refineModelForRequest } from '@/client/formatters/utils';
import { getConfig } from '@/config';
import { updatePinnedRefinementsPriorities } from '../utilities';
import { NavigationSortOrder, NavigationType } from '@/search-for-retail/models';
const generateSortObject = (sort) => {
    if (sort === NavigationSortOrder.ValueAscending)
        return undefined;
    const [field, orderType] = sort ? sort.split('-') : SORT_ORDER_OPTIONS[0].value.split('-');
    return { field, orderType };
};
export const formatDynamicNavigation = (_a) => {
    var { areaId, sort, pinnedRefinements, type, ranges } = _a, model = __rest(_a, ["areaId", "sort", "pinnedRefinements", "type", "ranges"]);
    const config = getConfig();
    const requestModel = refineModelForRequest(model);
    const sortValue = (type === NavigationType.Value && sort) ? generateSortObject(sort) : undefined;
    const rangesValue = (type === NavigationType.Value || (ranges === null || ranges === void 0 ? void 0 : ranges.length) === 0) ? undefined : ranges;
    return Object.assign(Object.assign({}, requestModel), { sort: sortValue, ranges: rangesValue, areaId, merchandiser: {
            merchandiserId: config.customer,
        }, pinnedRefinements: updatePinnedRefinementsPriorities(pinnedRefinements), type });
};
export default formatDynamicNavigation;
